import { render, staticRenderFns } from "./SettingsFontList.vue?vue&type=template&id=06ffe242&scoped=true&"
import script from "./SettingsFontList.vue?vue&type=script&lang=js&"
export * from "./SettingsFontList.vue?vue&type=script&lang=js&"
import style0 from "./SettingsFontList.vue?vue&type=style&index=0&id=06ffe242&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ffe242",
  null
  
)

export default component.exports